let boundStartView: ((name: string) => void) | null = null;
let pendingView: string | null = null;

export function bindDatadogView(startView: (name: string) => void): void {
  boundStartView = startView;
  if (pendingView !== null) {
    try {
      startView(pendingView);
    } catch (err) {
      console.error('[analyticsQueue] datadog startView failed:', err);
    }
    pendingView = null;
  }
}

export const datadogView = {
  start(name: string): void {
    if (boundStartView) boundStartView(name);
    else pendingView = name;
  },
};

let boundSetUser: ((id: string) => void) | null = null;
let boundClearUser: (() => void) | null = null;
let pendingUser: { id: string } | 'cleared' | null = null;

export function bindDatadogUser(handlers: {
  setUser: (id: string) => void;
  clearUser: () => void;
}): void {
  boundSetUser = handlers.setUser;
  boundClearUser = handlers.clearUser;
  if (pendingUser === null) return;
  const queued = pendingUser;
  pendingUser = null;
  try {
    if (queued === 'cleared') handlers.clearUser();
    else handlers.setUser(queued.id);
  } catch (err) {
    console.error('[analyticsQueue] datadog setUser failed:', err);
  }
}

export const datadogUser = {
  set(id: string): void {
    if (!boundSetUser) {
      pendingUser = { id };
      return;
    }
    try {
      boundSetUser(id);
    } catch (err) {
      console.error('[analyticsQueue] datadog setUser failed:', err);
    }
  },
  clear(): void {
    if (!boundClearUser) {
      pendingUser = 'cleared';
      return;
    }
    try {
      boundClearUser();
    } catch (err) {
      console.error('[analyticsQueue] datadog clearUser failed:', err);
    }
  },
};
